import type { MonthScheduleData, ServiceDay, OffDay } from '@types'

/**
 * Mock coordinator — returns schedule data for a given month.
 * Weekdays are service days; 2nd & 4th Wednesdays are off days.
 * Will be replaced with a real API call once the backend endpoint exists.
 */
export const GetMonthScheduleData =
  () =>
  async (year: number, month: number): Promise<MonthScheduleData> => {
    const daysInMonth = new Date(year, month + 1, 0).getDate()
    const serviceDays: ServiceDay[] = []
    const offDays: OffDay[] = []

    let wedCount = 0

    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d)
      const dow = date.getDay() // 0=Sun, 6=Sat
      if (dow === 0 || dow === 6) {
        continue
      } // skip weekends

      const iso = `${year}-${String(month + 1).padStart(2, '0')}-${String(
        d,
      ).padStart(2, '0')}`

      if (dow === 3) {
        // Wednesday
        wedCount++
        if (wedCount === 2 || wedCount === 4) {
          offDays.push({
            date: iso,
            scheduleName: 'Default Schedule',
            reason: wedCount === 2 ? 'Low Attendance' : 'Office Closure',
            notes:
              wedCount === 2
                ? 'Historically low turnout on 2nd Wednesday'
                : 'Building maintenance scheduled',
          })
          continue
        }
      }

      serviceDays.push({
        date: iso,
        scheduleName: 'Default Schedule',
        dropoffTime: 1200,
        cutoffTime: 1400,
        cutoffDaysBefore: 1,
      })
    }

    return { serviceDays, offDays }
  }
